import React from 'react';
import { string } from 'prop-types';
import InputValidationType from './InlineValidationType';
import { Text, ErrWarningIcon, Wrapper } from './StyledInlineMessage';

/** A component to display an error or warning. */
export default class InlineValidationMessage extends React.PureComponent {
  static propTypes = {
    /**
     * ID property
     */
    id: string,
    /**
     * AutomationID property
     */
    automationId: string,
    /**
     * message property
     */
    message: string,
    /**
     * Determines the type of Validation Message : ['error', 'warning']
     */
    type: InputValidationType
  };

  static defaultProps = {
    id: undefined,
    automationId: 'idsInlineValidationMessage',
    message: '',
    type: ''
  };

  render() {
    const { id, automationId, message, type } = this.props;

    const role = type === 'error' ? 'alert' : undefined;

    return (
      message &&
      type && (
        <Wrapper
          role={role}
          id={id}
          data-automation-id={`${automationId}-alertMsg`}
        >
          <ErrWarningIcon type={type} />
          <Text type={type} message={message}>
            {message}
          </Text>
        </Wrapper>
      )
    );
  }
}
